import ProjectCard from './project-card';

export default ProjectCard;